import React, { useState } from 'react';
import * as yup from 'yup';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Dialog, DialogProps, ElevatedButton, TextButton, TextInput } from '@producer/ui-kit';

import { WeatherSelect } from './weather.select';
import { Step } from '../../../app/entities/step';

import styles from './weather.modal.module.scss';
type WeatherModalProps = DialogProps & {
  step: Step;
  defaultValues?: FormValues;
  onClose: () => void;
};

type FormValues = {
  temp: {
    min: string;

    max: string;
  };

  sunrise: string;

  sunset: string;

  description: string;
};

const schema = yup.object().shape({
  temp: yup.object().shape({
    min: yup.string().max(6),
    max: yup.string().max(6),
  }),
  sunrise: yup.string().max(8),
  sunset: yup.string().max(8),
  description: yup.string(),
});

export const WeatherModal: React.FC<WeatherModalProps> = ({ onClose, step, defaultValues }) => {
  const [isLoading, setIsLoading] = useState(false);

  const { control, register, handleSubmit } = useForm<FormValues>({
    mode: 'onSubmit',
    resolver: yupResolver(schema),
    defaultValues: defaultValues || {
      temp: {
        min: '-1°C',
        max: '5°C',
      },
      sunrise: '07:00',
      sunset: '20:00',
      description: 'clear sky',
    },
  });

  const onSubmit = async (values: FormValues) => {
    if (isLoading) {
      return;
    }

    setIsLoading(true);

    await step.update({
      info: {
        weather: values,
      },
    });

    onClose();
  };

  return (
    <Dialog
      title={'Weather'}
      onClose={onClose}
      actions={[
        <TextButton key={'cancel'} onClick={onClose} text={'Cancel'} />,
        <ElevatedButton
          key="save"
          text={'Save'}
          onClick={handleSubmit(onSubmit)}
          isLoading={isLoading}
        />,
      ]}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={styles['grid']}>
          <TextInput label="Min temp." {...register('temp.min')} />
          <TextInput label="Max temp." {...register('temp.max')} />
          <TextInput label="Sunrise" {...register('sunrise')} />
          <TextInput label="Sunset" {...register('sunset')} />

          <div
            style={{ gridColumn: 'span 2', display: 'flex', flexDirection: 'column', gap: '.8rem' }}
          >
            <label>Weather</label>

            <Controller
              name="description"
              control={control}
              render={({ field }) => (
                <WeatherSelect value={field.value} onChange={field.onChange} />
              )}
            />
          </div>
        </div>
      </form>
    </Dialog>
  );
};
